import { getFromStorage } from "../../../services/Admin/session-storage/storage.services"

const useAuth = () => {

  const values = getFromStorage(['accessToken', 'id'])
  
  if (Object.keys(values).length === 0) {
    return false
  }

  if (typeof values['accessToken'] !== 'undefined' && typeof values['id'] !== 'undefined') {
    return true
  } else {
    return false
  } 
    
}

export default useAuth